import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  constructor(private db: AngularFirestore) {}

  listenIndicator(indicatorType: AlterIndicatorTypes) {
    return this.db.collection('alerts').doc(indicatorType).valueChanges();
  }
}

export enum AlterIndicatorTypes {
  USER_REQUESTS = 'racketRequests',
}
